<template>
  <div class="container">
    <div class="columns">
      <div class="column is-one-quarter"></div>
      <div class="column is-one-half">
        <div class="card">
          <div
            class="card-header"
            style="padding: 20px; margin-bottom: 10px; background-color: #eb4b1b;"
          >
            <h5 class="title is-5 has-text-white">Unfunded List Application Portal</h5>
          </div>
          <div class="card-body" style="padding: 20px">
            <form @submit.prevent="authenticateUser(userData)">
              <div class="field">
                <label class="label">E-mail Address</label>
                <div class="control">
                  <input class="input" v-model="userData.email" />
                </div>
              </div>
              <div class="field">
                <label class="label">Password</label>
                <div class="control">
                  <input class="input" type="password" v-model="userData.password" />
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <button
                    class="button is-primary"
                    :class="{ 'is-loading': loggingIn }"
                    style="margin-top: 15px"
                  >
                    Log In
                  </button>
                </div>
              </div>
            </form>
            <div class="has-text-centered" style="padding-top:40px">
              <em
                >If you have forgotten your username and password, please refer to your assignment
                email for a magic link, or email dave@unfundedlist.com.</em
              >
              <!-- <h6 class="title is-6">Sign Up</h6>
              <h6 class="title is-6">Forgot Password</h6> -->
            </div>
          </div>
          <div
            class="card-footer"
            style="padding: 10px; margin-top: 10px; background-color: #eb4b1b;"
          ></div>
        </div>
      </div>
      <div class="column is-one-quarter"></div>
    </div>
  </div>
</template>

<script>
import Auth from '@/services/auth'

export default {
  data() {
    return {
      userData: {
        email: '',
        password: '',
      },
      loggingIn: false,
    }
  },
  created() {
    this.$store.commit('LOGOUT_USER')
  },
  methods: {
    authenticateUser() {
      this.loggingIn = true
      Auth.login(this.userData.email, this.userData.password)
        .then(response => {
          //console.log("authenticateuser")
          //console.log(response)
          this.$store.commit('UPDATE_USER', {
            user: response,
            authToken: response.token,
          })
          this.loggingIn = false
          if (this.$store.state.user.is_staff) {
            this.$router.push({ name: 'EvaluatorsEmailOverview' })
          } else {
            this.$router.push({ name: 'ApplicationReview' })
          }
        })
        .catch(error => {
          this.loggingIn = false
          const { response } = error
          if (response) {
            this.$Alert.alert({
              type: 'error',
              message: `<p>Login error, please email dave@unfundedlist.com if you continue to have issues.`,
              timeout: 6000,
            })
            return
          }
          throw error
        })
    },
  },
}
</script>

<style scoped></style>
